module.exports = __webpack_public_path__ + "img/leadvertex.048dce0f.png";